import React, { Component } from 'react'
import { Col, Row } from 'antd';
import moment from 'moment-business-days';
import { dateFormat, simpleDateTimeFormat } from '../../lib/DateFormat';

export default class InfoOrders extends Component {

    render() {
        const { t, order, isQuotation } = this.props
        const title = (isQuotation) ? t('Quotation') : t('Order')
        return (
            <Col>
                <Row>
                    <Col>
                        <h4>{title}</h4>
                    </Col>
                </Row>
                {!isQuotation && <Row>
                    <Col span={6}>
                        <b>{t('SAP Code')}</b>
                    </Col>
                    <Col span={15} >
                        {order.numeroPedidoSAP}
                    </Col>
                </Row>}
                <Row>
                    <Col span={6}>
                        <b>{t('Status')}</b>
                    </Col>
                    <Col span={15} >
                        {t(`STATUS_${order.status.toUpperCase()}`)}
                    </Col>
                </Row>
                {isQuotation && <Row>
                    <Col span={6}>
                        <b>{t('Valid until')}</b>
                    </Col>
                    <Col span={15} >
                        {moment(order.fecha_validez).format(dateFormat)}
                    </Col>
                </Row>}
                <Row>
                    <Col span={6}>
                        <b>{t('Create date')}</b>
                    </Col>
                    <Col span={15} >
                        {moment(order.createdAt).format(simpleDateTimeFormat)}
                    </Col>
                </Row>
                <Row>
                    <Col span={6}>
                        <b>{t('Update date')}</b>
                    </Col>
                    <Col span={15} >
                        {moment(order.updatedAt).format(simpleDateTimeFormat)}
                    </Col>
                </Row>
                <Row>
                    <Col span={6}>
                        <b>{t('Remarks')}</b>
                    </Col>
                    <Col span={15} >
                        {order.observaciones}
                    </Col>
                </Row>
            </Col>
        )
    }
}
